import { render, staticRenderFns } from "./BenefitsPaid.vue?vue&type=template&id=269b6a23&"
import script from "./BenefitsPaid.vue?vue&type=script&lang=ts&"
export * from "./BenefitsPaid.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports